import { exhaustiveGuard, type Nil, isNotNil, isStringLiteralOfType } from "@mcwd/typescript-type-guards";
import type { IFormSettings } from "../../form-settings/form-settings-factory.js";
import { getHighestPriorityGatingLevel } from "./priority/get-highest-priority-gating-level.js";
import type { GatingLevel, GatingLevelFor } from "../../types/definitions/gating/gating-level.js";
import { FormOrFormExperienceType } from "./FormOrFormExperienceType.js";
import { getResourceGatingLevel } from "./get-resource-gating-level.js";

export function getGatingLevelFromResources<TFormOrExperience extends FormOrFormExperienceType>(
  type: TFormOrExperience,
  settings: IFormSettings,
  resources: { gatingLevel: GatingLevel.Resource.Raw }[]
):  GatingLevelFor<TFormOrExperience> | Nil {
  type ThisReturnType = GatingLevelFor<TFormOrExperience> | Nil;
  if (resources.length === 0) {
    return null;
  }
  const { allowedGatingStates } = settings;
  const resourceGatingLevels = resources.map(r => getResourceGatingLevel(r));
  const filteredResourceGatingLevels = resourceGatingLevels.filter(rgl => isStringLiteralOfType(rgl, allowedGatingStates));
  const returnVal = getHighestPriorityGatingLevel(type, filteredResourceGatingLevels) as ThisReturnType;
  if (isNotNil(returnVal)) {
    return returnVal;
  }
  const highestSettingsLevel = getHighestPriorityGatingLevel(type, allowedGatingStates) as ThisReturnType;
  if (isNotNil(highestSettingsLevel)) {
    return highestSettingsLevel;
  }
  if (isStringLiteralOfType(type, FormOrFormExperienceType)) {
    throw new Error(`Property 'allowedGatingStates' for formSettingsKey "${ settings.formSettingsKey }" does not contain any valid values of type [GatingLevel.${ type }]`);
  }
  exhaustiveGuard(type);
}
